const initialState = []
console.log('SERVICES REDUCER FILE LOADED')

export default (state = initialState, action) => {
  console.log('SERVICES REDUCER ACTION:', action)

  switch (action.type) {
    case 'FETCH_SESSION_SUCCESS':
      return action.payload.services
    default:
      return state
  }
}
